<template>
    <div role="tabpanel" class="inline-tabs">
        <ul role="tablist" class="nav nav-tabs">
            <li v-for="tab in tabs" :key="tab.name" role="presentation" :class="{active: tab.isActive}">
                <a href="#" aria-controls="courses" role="tab" template-toggle="tab"
                   @click.prevent="select(tab)" @focus.prevent="select(tab)">
                    <i v-if="!empty(tab.icon)" :class="tab.icon"></i> {{ tab.name }}
                </a>
            </li>
        </ul>

        <div class="tab-content">
            <slot />
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import lscache from 'lscache';

export default {
  data() {
    return {
      tabs: [],
    };
  },

  computed: {
    storageKey() {
      let type = this.getTypeInItemStack();
      if (!type) type = window.location.host + window.location.pathname;

      return `kwInternTabs.cache.${type}`;
    },
  },

  created() {
    this.tabs = this.$children;
  },

  mounted() {
    const previousSelectedTab = lscache.get(this.storageKey);
    const tab = this.find(previousSelectedTab);

    if (tab) {
      this.select(tab);
    } else if (this.tabs.length > 0) {
      this.select(this.tabs[0]);
    }
  },

  methods: {
    find(name) {
      return name !== null ? _.find(this.tabs, ['name', name]) : null;
    },

    select(selected) {
      _.each(this.tabs, (tab) => {
        tab.isActive = (tab === selected);
      });

      lscache.set(this.storageKey, selected.name, 10);
    },
  },
};
</script>

<style>
    .nav-tabs > li {
        user-select: none;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/tabs.vue